@if (value != undefined) {
    <bizz-conditional-bg-tag
            [value]="value | decimal: column.MaxDecimals"
            [backgroundColor]="backgroundColor"
            [foregroundColor]="foregroundColor"
            [columnHasDisplayStyle]="columnHasDisplayStyle"
            [disableTruncate]="enableListMultiline">
    </bizz-conditional-bg-tag>
}

